import { createAction } from "../../actions/actionUtils.js";

import { ENDPOINTS } from "../../../constants/api.js";
import { ACCOUNT } from "./accountConstants.js";
import {
  PASSWORD_REQUEST,
  PASSWORD_RESET,
  PASSWORD,
  USERNAME_RECOVERY,
  USERNAME,
  VERIFICATION_RECOVERY,
  VERIFY
} from "../../actions/actionConstants.js";

// -- ACCOUNT MANAGEMENT -- //

export const getAccount = () => createAction(ACCOUNT.GET);

export function updateAccount(data) {
  return {
    type: ACCOUNT.PUT,
    payload: {
      ...data
    }
  };
}

export function setTimezone(timezone) {
  return {
    type: ACCOUNT.SET_TIMEZONE,
    payload: { timezone }
  };
}

// -- PASSWORD RECOVERY -- //

export function passwordRequest(data) {
  return {
    type: PASSWORD_REQUEST,
    payload: {
      ...data,
      endpoint: ENDPOINTS.PASSWORD_RESET
    }
  };
}

export function passwordReset(data) {
  return {
    type: PASSWORD_RESET,
    payload: {
      password: data.password,
      passwordConfirmation: data.passwordConfirmation,
      endpoint: `${ENDPOINTS.PASSWORD_RESET}/${data.token}`
    }
  };
}

// used to reset isError, isSuccess etc on store
export function resetPasswordStore() {
  return {
    type: PASSWORD.RESET
  };
}

// -- USERNAME RECOVERY -- //

export function usernameRequest(data) {
  return {
    type: USERNAME_RECOVERY,
    payload: {
      ...data,
      endpoint: ENDPOINTS.USERNAME_RECOVERY
    }
  };
}

// used to reset isError, isSuccess etc on store
export function resetUsernameStore() {
  return {
    type: USERNAME.RESET
  };
}

// -- VERIFICATION RECOVERY -- //

export function verificationRecoveryRequest(data) {
  return {
    type: VERIFICATION_RECOVERY,
    payload: {
      ...data,
      endpoint: ENDPOINTS.VERIFICATION_RECOVERY
    }
  };
}

// used to reset isError, isSuccess etc on store
export function resetVerificationStore() {
  return {
    type: VERIFY.RESET
  };
}
